import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ShowInEpcotDirective } from '@frontend/sports/common/core/feature/show-in-epcot';
import { ParticipantImageComponent, ParticipantImageService } from '@frontend/sports/participant-image/feature';
import { DsDivider } from '@frontend/ui/divider';
import { DsTabsModule } from '@frontend/ui/tabsgroup';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BadgeComponent } from '../crm-promotion/badge.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionPanelBottomActionComponent } from './option-panel-bottom-action.component';
import { OptionComponent } from './option.component';
import { PlayerMilestoneBaseOptionGroupComponent } from './player-milestone-base-option-group.component';
import { BaseOptionGroupStatisticsService } from './player-statistics/base-option-group-statistics.service';
import { OptionGroupPlayerStatisticsService } from './player-statistics/option-group-player-statistics.service';
import { PlayerStatisticsComponent } from './player-statistics/player-statistics.component';
import { PlayerStatsComponent } from './player-stats/player-stats.component';
import { TeamGroupingTabBarComponent } from './team-grouping/team-grouping-tab-bar.component';

@Component({
    selector: 'ms-player-milestone-option-group',
    templateUrl: './player-milestone-option-group.component.html',
    styleUrl: './player-milestone-option-group.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ParticipantImageService, OptionGroupPlayerStatisticsService, BaseOptionGroupStatisticsService],
    imports: [
        MarketHelpComponent,
        ShowInEpcotDirective,
        OptionPanelBottomActionComponent,
        BadgeComponent,
        PlayerStatsComponent,
        OptionComponent,
        NgClass,
        SlicePipe,
        TeamGroupingTabBarComponent,
        ParticipantImageComponent,
        DsTabsModule,
        DsDivider,
        PlayerStatisticsComponent,
        IconCustomComponent,
    ],
})
export class PlayerMilestoneOptionGroupComponent extends PlayerMilestoneBaseOptionGroupComponent {
    readonly optionGroupPlayerStatisticsService = inject(OptionGroupPlayerStatisticsService);
}
